import { theme } from '../../theme'

/** Width of Drawer */
export const drawerWidth = theme.spacing(37.5)
